/**
 * Scans written content for case-insensitive boundary-aware matches of `@Person Name`.
 * Returns an array of unique Person IDs that were mentioned.
 */
export const getLinkedPeopleIds = (
  content: string,
  people: Array<{ id: string; name: string }>
): string[] => {
  if (!content) return [];
  const matchedIds: string[] = [];
  
  for (const person of people) {
    // Escape special characters in the name to make it regex-safe
    const escapedName = person.name.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    // Regex matching @Name followed by a boundary, space, or end of string
    const regex = new RegExp(`@${escapedName}(?:\\b|\\s|$)`, 'i');
    
    if (regex.test(content)) {
      matchedIds.push(person.id);
    }
  }
  
  return matchedIds;
};
